/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import moment from 'moment';
import { Form, Tooltip, notification } from 'antd';
import { ClipboardList } from 'lucide-react';
import {
  fetchCalenderDetails,
  fetchLogDetails,
  generateLogReports,
} from '../redux/logDetails/action';
import { fetchSowDetails } from '../redux/sowDetails/actions';
import GenerateReport from './GenerateReport';
import LogCalender from './LogCalender';
import './LogDetails.css';

const LogDetails = (props) => {
  const {
    onFetchLogDetails,
    logDetails,
    showLogLoader,
    selectedProject,
    onFetchSowDetails,
    sowDetails,
    onGenerateLogReports,
    onFetchCalenderDetails,
    isCalenderLoading,
    calenderData,
    isLogReportsLoading,
    projectTeamMembersAccessList,
    userAccessList,
    testTypesList,
  } = props;

  const [isReportModalVisible, setIsReportModalVisible] = useState(false);
  const [columnList, setColoumList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [projectIdValue, setProjectIdValue] = useState(false);

  const [pipeline, setPipeline] = useState(null);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [yearData, setYearData] = useState(moment().format('YYYY'));
  const [monthData, setMonthData] = useState(moment().format('MM'));
  const [calenderList, setCalenderList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [calenderForm] = Form.useForm();
  const [calenderView, setCalenderView] = useState(false);
  const [calenderClass, setCalenderClass] = useState('hide');
  const [stationTests, setStationTests] = useState([]);

  const calendarAutoLoadedRef = useRef(false);

  const isButtonDisabled = () => {
    if (userAccessList.includes('admin') || userAccessList.includes('super-admin')) return false;
    else if (projectTeamMembersAccessList[0]?.isGuestUser) {
      return true;
    } else if (
      projectTeamMembersAccessList[0]?.isNormalUser &&
      !projectTeamMembersAccessList[0]?.tabPermissions?.Log?.write
    ) {
      return true;
    } else {
      return false;
    }
  };
  const isWriteAccess = isButtonDisabled();

  useEffect(() => {
    const projId = get(selectedProject, 'id', undefined);
    if (projId) {
      onFetchSowDetails(projId);
      setLocationData([]);
      setPipeline('');
      setSelectedPipeline('');
      setYearData(moment().format('YYYY'));
      setMonthData(moment().format('MM'));
      calenderForm.resetFields();
      setCalenderList([]);
      setDataList([]);
      setColoumList([]);
      setCalenderView(false);
      setCalenderClass('hide');
      calendarAutoLoadedRef.current = false;
    }
    setProjectIdValue(projId);
  }, [selectedProject]);

  useEffect(() => {
    setLocationData(sowDetails);
  }, [sowDetails]);

  /** Default pipeline + current month/year and load calendar weld counts */
  useEffect(() => {
    if (!locationData?.length || calendarAutoLoadedRef.current) return;

    const firstPipeline = locationData[0];
    if (!firstPipeline?.id) return;

    calendarAutoLoadedRef.current = true;
    const currentYear = moment().format('YYYY');
    const currentMonth = moment().format('MM');

    setPipeline(firstPipeline.pipelineSection);
    setSelectedPipeline(firstPipeline);
    setYearData(currentYear);
    setMonthData(currentMonth);

    calenderForm.setFieldsValue({
      pipeline: firstPipeline.pipelineSection,
      year: Number(currentYear),
      month: moment().month(),
    });

    onFetchCalenderDetails({
      sowId: firstPipeline.id,
      year: currentYear,
      month: currentMonth,
    });
  }, [locationData]);

  useEffect(() => {
    let logColoums = [];
    let logDataSource = [];
    if (logDetails) {
      setTotalCount(logDetails.totalCount);
      if (logDetails.columns) {
        logDetails.columns.forEach((item) => {
          item.width = 170;
          item.align = 'center';
          item.ellipsis = { showTitle: false };
          logColoums.push(item);
        });

        logColoums.forEach((item, i) => {
          if (item.title === 'Weld') {
            item.title = 'Weld #';
            item.width = 200;
            item.align = 'center';
            item.fixed = 'left';
            item.ellipsis = {
              showTitle: false,
            };
            (item.render = (address) => (
              <Tooltip
                placement="topLeft"
                title={address}
              >
                {address}
              </Tooltip>
            )),
              logColoums.splice(i, 1);
            logColoums.unshift(item);
          }

          if (item.title === 'Repair Status') {
            item.fixed = 'right';
            logColoums.splice(i, 1);
            logColoums.splice(logColoums.length - 1, 0, item);
          }

          if (item.title === 'Overall Status') {
            item.fixed = 'right';
          }
        });

        logColoums.forEach((item) => {
          if (item.title && typeof item.title === 'string') {
            item.columnTitle = item.title;
            item.ellipsis = {
              showTitle: false,
            };
            item.title = <Tooltip title={item.title}>{item.title}</Tooltip>;
          }
        });
        setColoumList(logColoums);
      }

      if (logDetails.dataSource) {
        var sizeCount = JSON.parse(sessionStorage.getItem('page'));
        logDetails.dataSource.map((item, i) => {
          if (sizeCount.pageIndex > 0) {
            item.count = i + 1 + sizeCount.pageSize * sizeCount.pageIndex;
          } else {
            item.count = i + 1;
          }

          logDataSource.push(item);
        });
        setDataList(logDataSource);
      }
    }
  }, [logDetails]);

  useEffect(() => {
    if (calenderData) {
      setCalenderList(calenderData);
    }
  }, [calenderData]);

  const onGenerateReport = async (data) => {
    await onGenerateLogReports(data);
  };

  const getCalData = async (data) => {
    await onFetchCalenderDetails(data);
  };

  return (
    <div className="modern-log-page">
      <div className="log-page-header">
        <div className="log-page-header-text">
          <div className="log-page-header-icon" aria-hidden>
            <ClipboardList size={22} color="#2563eb" />
          </div>
          <div className="log-page-header-titles">
            <h1 className="log-page-title">Inspection Report</h1>
            <p className="log-page-subtitle">
              Pipeline calendar, weld counts, and daily log details for this project.
            </p>
          </div>
        </div>
        <div className="log-page-header-actions">
          <GenerateReport
            isReportModalVisible={isReportModalVisible}
            setIsReportModalVisible={setIsReportModalVisible}
            setLocationData={setLocationData}
            locationData={locationData}
            projectIdValue={projectIdValue}
            onGenerateReport={onGenerateReport}
            isLogReportsLoading={isLogReportsLoading}
            isWriteAccess={isWriteAccess}
          />
        </div>
      </div>

      <div className="log-page-content">
        <LogCalender
          locationData={locationData}
          dataList={dataList}
          setDataList={setDataList}
          showLogLoader={showLogLoader}
          columnList={columnList}
          totalCount={totalCount}
          setCalenderView={setCalenderView}
          calenderView={calenderView}
          calenderClass={calenderClass}
          setCalenderClass={setCalenderClass}
          pipeline={pipeline}
          setPipeline={setPipeline}
          selectedPipeline={selectedPipeline}
          setSelectedPipeline={setSelectedPipeline}
          yearData={yearData}
          setYearData={setYearData}
          monthData={monthData}
          setMonthData={setMonthData}
          calenderForm={calenderForm}
          getCalData={getCalData}
          calenderList={calenderList}
          isCalenderLoading={isCalenderLoading}
          onFetchLogDetails={onFetchLogDetails}
          isWriteAccess={isWriteAccess}
          stationTests={stationTests}
          setStationTests={setStationTests}
          testTypesList={testTypesList}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ log, sow, testReducer }) => {
  const logDetails = get(log, 'logData', []);
  const reportsData = get(log, 'reportsData', []);
  const showLogLoader = get(log, 'isLogDetailsLoading', false);
  const sowDetails = get(sow, 'sowData', []);
  const isCalenderLoading = get(log, 'isCalenderLoading', []);
  const calenderData = get(log, 'calenderData', []);
  const isLogReportsLoading = get(log, 'isLogReportsLoading', []);
  const testTypesList = get(testReducer, 'testTypes', []);
  return {
    logDetails,
    showLogLoader,
    sowDetails,
    reportsData,
    isCalenderLoading,
    calenderData,
    isLogReportsLoading,
    testTypesList,
  };
};

const mapDispatchToProps = {
  onFetchLogDetails: fetchLogDetails,
  onFetchSowDetails: fetchSowDetails,
  onGenerateLogReports: generateLogReports,
  onFetchCalenderDetails: fetchCalenderDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(LogDetails);
